<template>
  <div class="loader-container"><Logo /></div>
</template>

<script>
import { Sine, TimelineMax } from 'gsap';
import Logo from './Logo';

export default {
  components: {
    Logo,
  },

  mounted() {
    this.tl = new TimelineMax({ repeat: Infinity });
    this.tl
      .staggerFrom(
        [].slice.call(this.$el.querySelectorAll('.animate-helper')).reverse(),
        0.875,
        { x: -5, alpha: 0, ease: Sine.easeOut, clearProps: 'all' },
        0.0875,
      )
      .staggerTo([].slice.call(this.$el.querySelectorAll('.animate-helper')).reverse(), 0.875, { x: 5, alpha: 0, ease: Sine.easeOut }, 0.0875);
  },

  beforeUnmount() {
    if (this.tl) {
      this.tl.kill();
    }
  },
};
</script>

<style scoped lang="scss">
.loader-container {
  position: absolute;
  z-index: 3;
  width: 36px;
  height: 36px;
  bottom: 30px;
  right: 30px;
  opacity: 0.75;
}
</style>
